<template>
    <header>
        <div class="header-logo">
            <div class="eg-logo"  style="text-decoration:none;min-width:460px">
                <img src="../../../static/img/nav/mengguo_logo.png" width="185" style="margin:0 10px 10px 10px;">
                <img src="../../../static/img/nav/header_logo.png" width="170" style="margin:0 10px 10px 10px;">
                <img src="../../../static/img/nav/logo1.png"   style="margin:0 10px 0 0; width: 80px;height: 73px;">

            </div>
        </div>
        <div class="header-nav">
            <router-link to="/home" class="nav-item" onclick="gaStat('导航', '首页')">
                {{ $t('home') }}
            </router-link>

            <router-link to="/about" class="nav-item" onclick="gaStat('导航', '关于我们')">
                {{ $t('about') }}
            </router-link>

            <router-link to="/game" class="nav-item" onclick="gaStat('导航', '游戏中心')">
                {{ $t('center') }}
            </router-link>

            <!--<router-link to="/store" class="nav-item" onclick="gaStat('导航', '在线商城')">-->
                <!--{{ $t('store') }}-->
            <!--</router-link>-->

            <router-link to="/business" class="nav-item" onclick="gaStat('导航', '商务合作')">
                {{ $t('business') }}
            </router-link>

            <router-link to="/news" class="nav-item" onclick="gaStat('导航', '新闻资讯')">
                {{ $t('news') }}
            </router-link>
        </div>
        <button v-if="global.isTest" @click="clearCache" class="btn" style="min-width:80px;">清除缓存</button>
        <div style="width:154px;height:36px;display:inline-block"></div>
        <!--<el-select v-model="value4" @change="changeLang">-->
            <!--<el-option v-for="item in options" :label="item.label" :value="item.value">{{ item.label }}</el-option>-->
        <!--</el-select>-->
        <!--<div class="lang-switch">-->
        <!--<span class="lang" @click="changeLang('zh-CN')" :class="{ 'lang-active': currentLang == 'zh-CN' }">中文</span>-->
        <!--<span class="lang" @click="changeLang('en-US')" :class="{ 'lang-active': currentLang == 'en-US' }">English</span>-->
        <!--<span class="lang" @click="changeLang('th-TH')" :class="{ 'lang-active': currentLang == 'th-TH' }">ภาษาไทย</span>-->
        <!--</div>-->
    </header>
</template>

<script>
    import Vue from 'vue'
    import Global from '../../config/global'
    let cuLang;
    if (localStorage.getItem('cuLang')) {
        cuLang = localStorage.getItem('cuLang');
    } else {
        cuLang = navigator.language;
        localStorage.setItem('cuLang', cuLang);
    }
    let locLang = 'English';
    if (cuLang === 'zh-CN') {
        locLang = '简体中文';
    } else if (cuLang === 'th-TH') {
        locLang = 'ภาษาไทย';
    } else if (cuLang === 'zh-TW') {
        locLang = '繁體中文';
    } else if (cuLang === 'vi-VN') {
        locLang = 'Tiếng việt';
    }
    export default {
        data() {
            return {
                options: [{
                    value: 'zh-CN',
                    label: '简体中文'
                }, {
                    value: 'en-US',
                    label: 'English'
                }, {
                    value: 'th-TH',
                    label: 'ภาษาไทย'
                }, {
                    value: 'zh-TW',
                    label: '繁體中文'
                }, {
                    value: 'vi-VN',
                    label: 'Tiếng việt'
                }],
                value4: locLang,
                global:Global
            }
        },
        computed: {
            currentLang() {
                return Vue.config.lang;
            }
        },
        methods: {
            changeLang(lang) {
                Vue.config.lang = lang;
                //本地存储选择语言
                localStorage.setItem('cuLang', lang);
            },
            clearCache(){
                //轮播图
                localStorage.removeItem('carouselData')
                localStorage.removeItem('carouselData_time')
                //新闻与新闻旁边app
                localStorage.removeItem('nearNewsData')
                localStorage.removeItem('nearNewsData_time')
                //热门游戏
                localStorage.removeItem('hotGameData')
                localStorage.removeItem('hotGameData_time')
                //游戏中心
                localStorage.removeItem('gameCenterData')
                localStorage.removeItem('gameCenterData_time')
                //新闻资讯第一页
                localStorage.removeItem('newsData')
                localStorage.removeItem('newsData_time')
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    $header-height: 70px;
    $font-size: 20px;

    header {
        width: 100%;
        height: $header-height;
        padding: 0 50px;
        box-sizing: border-box;
        @include flex;
        @include cross-center;
        @include main-justify;
        margin-bottom: -1px;
        position: fixed;
        top: 0;
        background: #fff;
        z-index: 99;
        box-shadow: 0 2px 6px #ccc;
    }

    .header-logo {
        min-width: 440px;
        height: $header-height;
        @include flex-row-center;
        .eg-logo {
            display: block;
            img {
                height: 45px;
            }
        }
    }

    .header-nav {
        height: $header-height;
        @include flex-row-center;
        .nav-item {
            width: 150px;
            height: $header-height;
            color: #000;
            font-size: $font-size;
            text-decoration: none;
            @include flex-row-center;
            @media screen and(max-width: 1350px) {
                width: 130px;
            }
            &:hover {
                color: #f08200;
                border-bottom: 5px solid #f08200;
                box-sizing: border-box;
                padding-top: 5px;
                transition: all .1s linear;
            }
        }
        .router-link-active {
            color: #f08200;
            border-bottom: 5px solid #f08200;
            box-sizing: border-box;
            padding-top: 5px;
        }
    }

    .lang-switch {
        height: $header-height;
        @include flex-row-center;
        font-size: $font-size;
        .lang {
            display: inline-block;
            width: 100px;
            cursor: pointer;
            color: #727272;
            border-right: 1px solid #000;
            text-align: right;
            padding-right: 8px;
            line-height: 25px;
            &:last-child {
                padding-left: 8px;
                border: 0;
            }
        }
    }

    .lang-active {
        color: #000 !important;
    }
</style>



// WEBPACK FOOTER //
// Header.vue?e99f9e18